<template lang="pug">
.py-2
  div
    .h6 Descreva a ocorrência
    .text-small Informe os detalhes da ocorrência
  .mt-2
    form-group(label="Descrição" :validation="$v.descricao")
      textarea.form-input(v-model="$v.descricao.$model" placeholder="Descreva a ocorrência" rows="5")
  .text-right.mt-2
    button.btn.btn-primary(:disabled="$v.$invalid" @click="onNext")
      | Avançar&nbsp;
      i.fa.fa-arrow-right
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  vuex: {
    ocorrencias: {
      state: ["form"],
      mutations: ["setForm"],
    },
  },
  data() {
    return {
      descricao: ''
    }
  },
  methods: {
    onNext() {
      this.setForm({
        ...this.form,
        descricao: this.descricao,
      });
      this.$router.push({ name: "app.ouvidoria.create.confirmar" });
    }
  },
  validations: {
    descricao: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(500)
    }
  },
  created() {
    this.descricao = this.form.descricao || '';
  }
};
</script>
